import slugify from 'slugify';
/**
 * This functions help to adapt v4 products to the v5 stores. SAM deals with some v4 specific info
 * but the network layer is too low level to deal with some v4 details.
 *
 * In other instances it may be that some details SAM is leaking involve a big refactor, dealing with
 * it first from this file will make it easier to finally move the logic to SAM.
 *
 * TODO: This is still not the proper place to handle the logic. We have to rethink SAM adapters and domain entities
 * to properly handle this. This solution just contains complexity avoiding duplication.
 */
/**
 *
 * Returns a product slug to be used in URLs it supports generating the slug from the SEO title and fallbacks
 * to the product title.
 */
export function getProductCanonicalSlug(product, lang) {
  const description = getSafeDescription(product, lang);
  if (description?.seo?.url) {
    return description.seo.url;
  }
  return slugify(description.title, {
    lower: true,
    strict: true
  });
}
/**
 * getSafeDescription returns a description for a product in a given language. It falls back to the first language
 */
export function getSafeDescription(product, lang) {
  if (!product.descriptions) {
    throw new Error(`No description found for product ${JSON.stringify(product)}`);
  }
  let description = product?.descriptions.find(item => item.lang === lang);
  if (!description) {
    description = product.descriptions[0];
  }
  return description;
}
